import { generateUUID } from '@ionic/cli/lib/utils/uuid'
import clsx from 'clsx'
import { useRef } from 'react'

import { useTalentCardContext } from '../Context'
import './style.scss'

interface TalentCardPaperSvgProp {
    isBackground?: boolean
}

const TalentCardPaperSvg: React.FC<TalentCardPaperSvgProp> = ({ isBackground }) => {
    const { talentType, talent, onClick, type } = useTalentCardContext()
    const uuidRef = useRef(generateUUID())

    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            xmlSpace={type === 'listItem' ? undefined : 'preserve'}
            width='100%'
            height='100%'
            version='1.1'
            className={clsx(`talentcard-paper-svg talentcard-paper-svg--${talentType}`)}
            viewBox='0 0 42000 68000'
            xmlnsXlink='http://www.w3.org/1999/xlink'
        >
            <defs>
                <linearGradient
                    id={`${uuidRef.current}-gradient`}
                    gradientUnits='userSpaceOnUse'
                    x1='21671'
                    y1='66123.1'
                    x2='21671.1'
                    y2='50333.6'
                >
                    <stop
                        className='talentcard-paper-svg__stop1'
                        offset='0'
                    />
                    <stop
                        className='talentcard-paper-svg__stop2'
                        offset='1'
                    />
                </linearGradient>

                <linearGradient
                    id={`${uuidRef.current}-gradient-image-top`}
                    gradientUnits='userSpaceOnUse'
                    x1='0'
                    y1='0'
                    x2='0'
                    y2='10000'
                >
                    <stop
                        offset='0'
                        style={{ stopColor: '#000000' }}
                    />
                    <stop
                        offset='1'
                        style={{ stopColor: '#000000', stopOpacity: 0 }}
                    />
                </linearGradient>

                <linearGradient
                    id={`${uuidRef.current}-gradient-image-bottom`}
                    gradientUnits='userSpaceOnUse'
                    x1='0'
                    y1='42000'
                    x2='0'
                    y2='20000'
                >
                    <stop
                        offset='0'
                        style={{ stopColor: '#000000' }}
                    />
                    <stop
                        offset='1'
                        style={{ stopColor: '#000000', stopOpacity: 0 }}
                    />
                </linearGradient>

                <linearGradient
                    id={`${uuidRef.current}-gradient-image`}
                    gradientUnits='userSpaceOnUse'
                    x1='0'
                    y1='0'
                    x2='42000'
                    y2='0'
                >
                    <stop
                        offset='0'
                        style={{ stopColor: '#000000', stopOpacity: 0.3 }}
                    />

                    <stop
                        offset='0.1'
                        style={{ stopColor: '#000000', stopOpacity: 0 }}
                    />

                    <stop
                        offset='0.9'
                        style={{ stopColor: '#000000', stopOpacity: 0 }}
                    />

                    <stop
                        offset='1'
                        style={{ stopColor: '#000000', stopOpacity: 0.3 }}
                    />
                </linearGradient>
            </defs>

            <g
                onClick={onClick}
            >
                <path
                    id={`${uuidRef.current}-imageContainer`}
                    className='talentcard-paper-svg__path1'
                    d='M42000 54246l0 -8267 0 -38781 -54 0c-1123,0 -2246,-5 -3290,-283 -1062,-284 -2043,-850 -3195,-1795 -1151,-944 -2473,-2266 -3854,-3342 -922,-720 -1870,-1329 -2928,-1778 -2503,2510 -13277,2087 -15358,0 -1058,449 -2006,1058 -2928,1778 -1381,1076 -2703,2398 -3854,3342 -1152,945 -2133,1511 -3195,1795 -1044,278 -2167,283 -3290,283l-54 0 0 38781 0 8267 0 1986c0,2565 2206,3927 4662,4663 7659,2295 13636,3158 16338,7105 2702,-3947 8679,-4810 16338,-7105 2456,-736 4662,-2098 4662,-4663l0 -1986z'
                />
                <path
                    style={{ fill: `url(#${uuidRef.current}-gradient)` }}
                    className='talentcard-paper-svg__path2'
                    d='M0 47965l0 6281 0 1986c0, 2565 2206,3927 4662,4663 7659,2295 13636,3158 16338,7105 2702,-3947 8679,-4810 16338,-7105 2456,-736 4662,-2098 4662,-4663l0 -1986 0 -6281 0 -1986 -42000 0 0 1986z'
                />

                { !isBackground && (
                    <>
                        {/* {hsv && ( */}
                        {/*     <> */}
                        {/*         <clipPath */}
                        {/*             id={`${uuidRef.current}-clipPathBackground`} */}
                        {/*         > */}
                        {/*             <use */}
                        {/*                 xlinkHref={`#${uuidRef.current}-imageContainer'`} */}
                        {/*                 style={{ overflow: 'hidden' }} */}
                        {/*             /> */}
                        {/*         </clipPath> */}
                        {/*         <g */}
                        {/*             style={{ clipPath: `url(#${uuidRef.current}-clipPath)` }} */}
                        {/*         > */}
                        {/*             <image */}
                        {/*                 preserveAspectRatio='xMidYMid slice' */}
                        {/*                 y='42000' */}
                        {/*                 opacity='0.3' */}
                        {/*                 x='0' */}
                        {/*                 width='42000' */}
                        {/*                 height='29000' */}
                        {/*                 xlinkHref='https://joinmytalent.krischey-schulz.de/assets/talentCard/raute.png' */}
                        {/*             /> */}
                        {/*         </g> */}
                        {/*     </> */}
                        {/* )} */}
                        <g>
                            <clipPath
                                id={`${uuidRef.current}-clipPath`}
                            >
                                <use
                                    xlinkHref={`#${uuidRef.current}-imageContainer`}
                                    style={{ overflow: 'hidden' }}
                                />
                            </clipPath>
                            <g
                                style={{ clipPath: `url(#${uuidRef.current}-clipPath)` }}
                            >
                                <image
                                    preserveAspectRatio='xMinYMin slice'
                                    width='42000'
                                    height='41900'
                                    xlinkHref={talent?.image ?? '/assets/talentCard/400x400.jpg'}
                                />

                                <rect
                                    x='0'
                                    y='0'
                                    style={{ fillRule: 'evenodd', clipRule: 'evenodd' , fill: `url(#${uuidRef.current}-gradient-image)` }}
                                    width='42000'
                                    height='42000'
                                />

                                <rect
                                    x='0'
                                    y='0'
                                    style={{ fillRule: 'evenodd', clipRule: 'evenodd' , fill: `url(#${uuidRef.current}-gradient-image-top)` }}
                                    width='42000'
                                    height='10000'
                                />

                                <rect
                                    x='0'
                                    y='20000'
                                    style={{ fillRule: 'evenodd', clipRule: 'evenodd' , fill: `url(#${uuidRef.current}-gradient-image-bottom)` }}
                                    width='42000'
                                    height='22000'
                                />
                                <rect
                                    x='31700'
                                    y='0'
                                    style={{ fillRule: 'evenodd', clipRule: 'evenodd' , fill: '#00000045' }}
                                    width='7000'
                                    height='45000'
                                />
                            </g>
                        </g>
                    </>
                )}

                <path
                    opacity={0.5}
                    className='talentcard-paper-svg__path3'
                    d='M1364 18012l0 106 0 38077c0,974 509,1687 1218,2217 722,540 1652,893 2472,1139 1446,433 2884,829 4322,1225l719 198c746,206 1493,413 2244,633 749,219 1494,449 2228,697 1166,395 2350,851 3464,1432 1085,566 2102,1250 2969,2109 867,-859 1884,-1543 2969,-2109 1114,-581 2298,-1037 3464,-1432 734,-248 1479,-478 2228,-697 751,-220 1498,-427 2244,-633l718 -198c1439,-396 2877,-791 4323,-1225 820,-246 1750,-599 2472,-1139 709,-530 1218,-1243 1218,-2217l0 -38077 0 -106 0 -9225c-376,-14 -749,-39 -1119,-84 -407,-48 -811,-121 -1213,-228 -706,-188 -1355,-475 -1968,-829 -609,-352 -1183,-772 -1739,-1228 -588,-482 -1152,-992 -1716,-1503 -689,-623 -1378,-1247 -2112,-1819l-52 -41c-56,-43 -34,-26 -53,-40l0 0c-206,-158 -413,-311 -624,-456 -209,-145 -424,-285 -645,-418 -101,-61 -195,-116 -283,-166 -76,-43 -153,-85 -232,-127 -1447,1002 -4543,1453 -7654,1453 -3363,0 -6755,-527 -8106,-1453 -322,171 -636,360 -942,563 -325,216 -639,445 -947,685 -734,572 -1423,1196 -2112,1819 -564,511 -1128,1021 -1716,1503 -556,456 -1130,876 -1739,1228 -613,354 -1262,641 -1968,829 -402,107 -806,180 -1213,228 -370,45 -743,70 -1119,84l0 9225zm39484 0l0 106 0 38077c0,1052 -545,1819 -1304,2387 -746,558 -1699,920 -2537,1171 -1426,428 -2877,827 -4328,1227 -153,42 -317,87 -717,197 -750,207 -1500,415 -2242,632 -742,218 -1482,446 -2219,695 -1159,392 -2334,845 -3435,1419 -1098,573 -2124,1268 -2991,2146l-75 76 -75 -76c-867,-878 -1893,-1573 -2991,-2146 -1101,-574 -2276,-1027 -3435,-1419 -737,-249 -1477,-477 -2219,-695 -742,-217 -1492,-425 -2242,-632 -411,-113 -562,-155 -717,-198 -1452,-399 -2903,-798 -4328,-1226 -838,-251 -1791,-613 -2537,-1171 -759,-568 -1304,-1335 -1304,-2387l0 -38077 0 -106 0 -9429 103 -4c401,-13 802,-38 1203,-86 398,-47 793,-118 1183,-222 688,-184 1320,-463 1917,-808 600,-346 1164,-759 1711,-1208 586,-481 1147,-989 1709,-1496 692,-627 1385,-1254 2124,-1830 313,-244 632,-477 959,-694 328,-217 666,-420 1018,-603l58 -30 52 38c1278,923 4666,1449 8037,1449 3112,0 6200,-449 7585,-1449l52 -38 58 30c98,51 196,104 294,160 105,59 201,115 289,168 221,133 440,276 656,425 216,149 426,304 632,462l0 1c55,41 33,24 53,40l53 41c739,576 1432,1203 2124,1830 562,507 1123,1015 1709,1496 547,449 1111,862 1711,1208 597,345 1229,624 1917,808 390,104 785,175 1183,222 401,48 802,73 1203,86l103 4 0 9429z'
                />
            </g>
        </svg>
    )
}

export default TalentCardPaperSvg
